import { useQuery } from "@tanstack/react-query";
import { useLoginContext } from "../../../App";
import { fetchQualitativeTypesData } from "../../../services/b2b-indicators-apiService";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { showNotification } from "../../b2b-common/Notification";
import { useContentContext } from "../../layout/Layout";

const useQualitativeTypes = (fetchValues = false) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-indicators');

    const getQualitativeTypes = async () => {
        try {
            const data = await fetchQualitativeTypesData(loginData.accessToken, fetchValues);
            return data;
        } catch (error) {
            console.error(error);
            showNotification(setNotification, t('Error fetching qualitative types'), 'error', 5000);
        }
    }

    const { data: qualitativeTypes } = useQuery({
        queryKey: ['qualitativeTypes', fetchValues],
        queryFn: () => getQualitativeTypes(),
    });

    return qualitativeTypes;

}

export default useQualitativeTypes;